import { GetTipoSpazioDisponibileQuery } from '../../_graphql/generated';

export type TipoSpazioDisponibileState = {
  loading: boolean;
  lista: GetTipoSpazioDisponibileQuery['energy_village_tipo_spazio_disponibile'];
  failure: any;
};

export const initialTipoSpazioDisponibileState: TipoSpazioDisponibileState = {
  loading: false,
  lista: [],
  failure: '',
};
